<template>
  <div class="pageHeader">
    <div class="mainLogo">
      <img id="mainImage" alt="MAF Logo" src="./assets/logo_main.png" />
    </div>
    <input class="menu-btn" type="checkbox" id="menu-btn" />
    <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>
    <ul class="menu">
      <li><a v-scroll-to="'#AboutUs'"><button  class="tablinks">ABOUT US</button></a></li>
      <!--<li><a v-scroll-to="'#Media'"><button class="tablinks" >MEDIA</button></a></li>-->
      <li><a v-scroll-to="'#TheApp'" ><button class="tablinks" >THE APP</button></a></li>
      <li><a v-scroll-to="'#IntegrateWUs'"><button class="tablinks" >FEEDBACK</button></a></li>
      <li><a href="https://making-authentic-friendships.myshopify.com/" target="_blank"><button class="tablinks" >MERCH</button></a></li>
      <li><a href="./MAFBeSmart.BeSafe.pdf" target="_blank"><button class="tablinks" >SAFETY</button></a></li>
      <li class="lastLink" style="margin-right:5px;margin-bottom:5px;"> <a href="https://portal.makingauthenticfriendships.com/signup"  target="_blank"><button class="tablinks">Sign Up</button></a></li>
      <li class="lastLink" style="margin-bottom:5px;"> <a href="https://portal.makingauthenticfriendships.com/signin"  target="_blank"><button class="tablinks">Sign In</button></a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "pageHeader",
  components: { 
  },
}
</script>

<style scoped>
.tablinks{
  font-family: 'chunk';
  text-transform: uppercase;
  font-weight:lighter;

}
.pageHeader {
  z-index: 3;
  background-color: white;
  /* box-shadow: 1px 1px 4px 0 rgba(0,0,0,.1); */
  width: 100%;
}
.lastLink{
  background:#F06377 !important;
  border-radius:25px;
}
.lastLink button{
  color:white !important;
}
.pageHeader ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  background-color: white;
}
.pageHeader li a {
  display: block;
  padding: 10px 20px;
  border-right: 1px solid #f4f4f4;
  text-decoration: none;
  cursor: pointer;
}
.pageHeader li a button{
  font-size:2.5vmax;
  background-color:transparent;
  border:none;
  outline: none;
  color:#F06377;
  cursor: pointer;
}
.pageHeader .mainLogo {
  display: block;
  /* position: absolute; */
  float: left;
  padding: -1px 20px;
  text-decoration: none;
}
#mainImage{
  padding: 2vw;
}
.pageHeader .menu {
  clear: both;
  max-height: 0;
  transition: max-height .2s ease-out;
  padding:0;
}
.pageHeader .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 28px 20px;
  position: relative;
  user-select: none;
}
.pageHeader .menu-icon .navicon {
  background: #F06377;
  display: block;
  height: 2px;
  position: relative;
  transition: background .2s ease-out;
  width: 18px;
}
.pageHeader .menu-icon .navicon:before,
.pageHeader .menu-icon .navicon:after {
  background: #F06377;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  transition: all .2s ease-out;
  width: 100%;
}
.pageHeader .menu-icon .navicon:before {
  top: 5px;
}
.pageHeader .menu-icon .navicon:after {
  top: -5px;
}
.pageHeader .menu-btn {
  display: none;
}
.pageHeader .menu-btn:checked ~ .menu {
  max-height: 340px;
}
.pageHeader .menu-btn:checked ~ .menu-icon .navicon {
  background: transparent;
}
.pageHeader .menu-btn:checked ~ .menu-icon .navicon:before {
  transform: rotate(-45deg);
}
.pageHeader .menu-btn:checked ~ .menu-icon .navicon:after {
  transform: rotate(45deg);
}
.pageHeader .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
.pageHeader .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
  top: 0;
}
@media (min-width: 768px) {
  .tablinks{
    padding:0;
  }
  .lastLink a{
    margin:0;
    padding:0;
  }

  .pageHeader {
    height: 90px;
  }
  .pageHeader li {
    float: left;
  }
  .pageHeader li a {
    padding: 1vw 2vw;
    
  }
  .pageHeader .menu {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 75%;
    float: right;
    clear: none !important;
    max-height: none;
    padding: 2vw 2vw 0 0;
    margin-top: 0;
  }
  .pageHeader .menu-icon {
    display: none;
  }
  .pageHeader li a button{
    font-size: 20px;
  }
}

@media only screen and (max-width: 715px) {
  .pageHeader .menu {
    width: 75%;
  }
}

@media only screen and (min-device-width : 765px) and (max-device-width : 850px){
  .pageHeader li a button{
    font-size:10px;
  }
}
@media only screen and (min-device-width : 851px) and (max-device-width : 1024px){
  .pageHeader li a button{
    font-size:12px;
  }
}
@media only screen and (min-device-width : 1025px) and (max-device-width : 1080px){
  .pageHeader li a button{
    font-size:13px;
  }
}
@media only screen and (min-device-width : 1081px) and (max-device-width : 1554px){
  .pageHeader li a button{
    font-size:15px;
  }
}

  

</style>